module.exports = __webpack_public_path__ + "img/park-info.5beda0cc.png";